module.exports = __webpack_public_path__ + "static/img/tdf-homePage.41dbafe.png";